import {
  ACCOUNT,
  CURRENT_AWARENESS,
  CURRENT_AWARENESS_ARTICLE,
  CURRENT_AWARENESS_REVIEW,
  DASHBOARD,
  LEGISLATION,
  LEGISLATION_MENU,
  LEGISLATION_CATEGORIES,
  LEGISLATION_FOLDERS,
  LEGISLATION_REVIEW,
  LOGIN,
  NOT_FOUND,
  DOCUMENTS_ALL,
  DOCUMENTS_MENU,
  DOCUMENTS_CONTENT,
  DOCUMENTS_REVIEW,
  DOCUMENTS_INTERVIEW,
  QA_CONTENT,
  QA_MENU,
  QA_REVIEW,
  SEARCH,
  SMART_SEARCH,
  SHARE,
  STATIC,
  UTILS,
  MW_ANALYTICS,
  MW_OVERVIEW,
  MW_DEAL_COMPARE,
  MW_DEAL_DETAILS,
  MW_LIST_DEALS,
  AOL_MENU,
  USER_ADMIN
} from 'constants/controllers'

export const SECTION_NEWS = 'news'
export const SECTION_QA = 'qa'
export const SECTION_LEGISLATION = 'legislation'
export const SECTION_DOCUMENTS = 'documents'
export const SECTION_MARKETS = 'markets'
export const SECTION_TRAINING = 'training'

export const SECTION_MAPPINGS: Record<string, string[]> = {
  [SECTION_NEWS]: [
    DASHBOARD,
    CURRENT_AWARENESS_REVIEW,
    CURRENT_AWARENESS,
    CURRENT_AWARENESS_ARTICLE
  ],
  [SECTION_QA]: [
    QA_REVIEW,
    QA_CONTENT,
    QA_MENU,
    SMART_SEARCH
  ],
  [SECTION_LEGISLATION]: [
    LEGISLATION_REVIEW,
    LEGISLATION,
    LEGISLATION_CATEGORIES,
    LEGISLATION_FOLDERS,
    LEGISLATION_MENU
  ],
  [SECTION_DOCUMENTS]: [
    DOCUMENTS_ALL,
    DOCUMENTS_CONTENT,
    DOCUMENTS_REVIEW,
    DOCUMENTS_INTERVIEW,
    DOCUMENTS_MENU
  ],
  [SECTION_MARKETS]: [
    MW_OVERVIEW,
    MW_ANALYTICS,
    MW_DEAL_COMPARE,
    MW_DEAL_DETAILS,
    MW_LIST_DEALS
  ]
}

export const DEFAULT_PAGES = [
  ACCOUNT,
  AOL_MENU,
  LOGIN,
  NOT_FOUND,
  SEARCH,
  SHARE,
  STATIC,
  UTILS,
  USER_ADMIN
]
